<ng-template cdkPortal>
    @if (authService.loggedIn() && chatStore.activeChannel() || chatStore.chats().length > 0) {
        <app-chat-floating-trigger (click)="chatStore.toggleChatWidget()" [unreadCount]="unreadMessageCount()" [hidden]="chatStore.chatWidgetExpanded()"/>
        <app-chat-window (close)="chatStore.toggleChatWidget()" [hidden]="!chatStore.chatWidgetExpanded()"/>
    }    
</ng-template>